import { render } from "./TheSideBar.vue?vue&type=template&id=26e6301a&scoped=true&bindings={\"active\":\"data\",\"otherProjectsActive\":\"data\",\"classActive\":\"data\",\"listActive\":\"data\",\"userId\":\"data\",\"userType\":\"data\",\"toggle\":\"options\",\"toggleList\":\"options\",\"toggleOtherProjects\":\"options\",\"isActive\":\"options\",\"isOtherProjectsActive\":\"options\",\"classObject\":\"options\",\"listObject\":\"options\"}"
import script from "./TheSideBar.vue?vue&type=script&lang=js"
export * from "./TheSideBar.vue?vue&type=script&lang=js"

import "./TheSideBar.vue?vue&type=style&index=0&id=26e6301a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26e6301a"

export default script